import { Turbo } from '@hotwired/turbo-rails';

document.addEventListener('turbo:load', function() {
  $('.guide__parent-nav-link').click(function() {
    Turbo.visit($(this).attr('href'));
  });
});
